

  document.addEventListener('DOMContentLoaded', function() {
  const footerMenu = document.querySelectorAll('.footer__block--links__title');
  footerMenu.forEach(item => {
    item.addEventListener('click', function() {
      const id = this.getAttribute('data-id');
      const el = document.querySelector(`[id^="footer__block--links__list_${id}"]`);
      if (!el.classList.contains('active')) { 
          el.style.display = 'flex';
          slideDown(el);
          el.classList.add('active');
          this.classList.add('active');
      } else {
        el.classList.remove('active');
        this.classList.remove('active');
        slideUp(el);
      }
    })
  })
  })

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.header-sidebar__linklist-button');
  if (!btn) return; 

  const id = btn.dataset.id;
  if (!id) return; 

  const target = document.getElementById(`header-sidebar__item_${id}`);
  if (!target) return;
 
  target.classList.toggle('active');
});  



function slideDown(element, duration = 300) {
  element.style.height = '0px';
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  
  setTimeout(() => {
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
}
 
function slideUp(element, duration = 300) {
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  
  setTimeout(() => {
    element.style.height = '0px';
  }, 10);
  
  setTimeout(() => {
    element.style.display = 'none';
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
}
document.addEventListener('click', function (e) { 
  if (e.target.closest('#collection__header__filter_open')) {
    const target = document.querySelector('.collection__flex');
    if (target) target.classList.add('active');
    return;
  }
 
  if (e.target.closest('#collection__header__filter_close')) {
    const target = document.querySelector('.collection__flex');
    if (target) target.classList.remove('active');
    return;
  }
});

(function(){
  const GRID = '.scroll_products_collection';
  const ITEM = '.featured-products__row_item';
  let loading = false;

  function getNextHref(){
    const pag = document.querySelector('nav.pagination');
    if(!pag) return null;
    const next = pag.querySelector('a[rel="next"]');
    return next ? next.href : null;
  }

  async function loadNext(){
    if(loading) return;
    const url = getNextHref();
    if(!url) return;

    loading = true;
    try{
      const res = await fetch(url, {credentials:'same-origin'});
      if(!res.ok) throw new Error(res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
 
      const newItems = (doc.querySelector(GRID)?.querySelectorAll(ITEM)) || doc.querySelectorAll(ITEM);
      const grid = document.querySelector(GRID);
      if(newItems && grid){
        const frag = document.createDocumentFragment();
        newItems.forEach(i => frag.appendChild(i.cloneNode(true)));
        grid.appendChild(frag);
      }
 
      const newPag = doc.querySelector('nav.pagination');
      const oldPag = document.querySelector('nav.pagination');
      if(newPag && oldPag) oldPag.innerHTML = newPag.innerHTML;
      else if(!newPag && oldPag) oldPag.remove();
    }catch(e){
      console.error(e);
    }finally{
      loading = false;
    }
  }

  function checkScroll(){
    const grid = document.querySelector(GRID);
    if(!grid) return;
    const rect = grid.getBoundingClientRect();
    const scrollTrigger = window.innerHeight + 200;  
    if(rect.bottom <= scrollTrigger){
      loadNext();
    }
  }

  function init(){
    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll); 
    checkScroll(); 
    document.addEventListener('collection:updated', checkScroll);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Cart Upsell - Toggle Variants
(function() {
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.cart-upsell__show-variants');
    if (!trigger) return;

    const form = trigger.closest('.cart-upsell__form');
    if (!form) return;

    const triggerContainer = form.querySelector('.cart-upsell__trigger');
    const variantSelector = form.querySelector('.cart-upsell__variant-selector');

    if (!triggerContainer || !variantSelector) return;

    triggerContainer.style.display = 'none';
    variantSelector.classList.remove('js:hidden');
    variantSelector.style.display = 'block';
  });

  document.addEventListener('change', function(e) {
    const select = e.target.closest('[data-variant-select]');
    if (!select) return;

    const variantId = select.value;
    if (!variantId) return;

    const form = select.closest('.cart-upsell__form');
    if (!form) return;

    const hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
      form.requestSubmit();
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-upsell__item')) return;

    const openSelectors = document.querySelectorAll('.cart-upsell__variant-selector:not(.js\\:hidden)');
    openSelectors.forEach(selector => {
      const form = selector.closest('.cart-upsell__form');
      if (!form) return;

      const triggerContainer = form.querySelector('.cart-upsell__trigger');
      if (!triggerContainer) return;

      selector.style.display = 'none';
      selector.classList.add('js:hidden');
      triggerContainer.style.display = 'block';
    });
  });

  let dragState = new Map();

  document.addEventListener('wheel', function(e) {
    const grid = e.target.closest('.cart-upsell__grid');
    if (!grid) return;

    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();

      grid.scrollBy({
        left: e.deltaY,
        behavior: 'auto'
      });

      grid.style.scrollBehavior = 'auto';

      if (grid._scrollTimer) clearTimeout(grid._scrollTimer);
      grid._scrollTimer = setTimeout(() => {
        grid.style.scrollBehavior = '';
      }, 100);
    }
  }, { passive: false, capture: true });

  let currentGrid = null;
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;
  let hasMoved = false;

  document.addEventListener('mousedown', function(e) {
    let target = e.target;
    while (target && target !== document) {
      if (target.classList && target.classList.contains('cart-upsell__grid')) {
        currentGrid = target;
        break;
      }
      target = target.parentElement;
    }

    if (!currentGrid) return;

    const interactive = e.target.closest('button, select, input, a[href]');
    if (interactive) return;

    isDragging = true;
    hasMoved = false;
    startX = e.pageX - currentGrid.offsetLeft;
    scrollLeft = currentGrid.scrollLeft;
    currentGrid.classList.add('is-dragging');
    currentGrid.style.scrollBehavior = 'auto';
    e.preventDefault();
  });

  document.addEventListener('mousemove', function(e) {
    if (!isDragging || !currentGrid) return;

    e.preventDefault();
    hasMoved = true;

    const x = e.pageX - currentGrid.offsetLeft;
    const walk = (x - startX) * 1.5;
    currentGrid.scrollLeft = scrollLeft - walk;
  });

  function stopDragging() {
    if (currentGrid) {
      currentGrid.classList.remove('is-dragging');
      currentGrid.style.scrollBehavior = '';
    }
    isDragging = false;
    currentGrid = null;
    hasMoved = false;
  }

  document.addEventListener('mouseup', stopDragging);

  document.addEventListener('click', function(e) {
    if (hasMoved && e.target.closest('.cart-upsell__grid')) {
      e.preventDefault();
      e.stopPropagation();
      hasMoved = false;
    }
  }, true);
})();
